import { IdsInput } from '../../lib/types/utils'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type DeleteEndOfJourneyQuestionsParams = {
  templateId: number
  input: IdsInput
}

export function deleteEndOfJourneyQuestions(params: DeleteEndOfJourneyQuestionsParams) {
  const { templateId, input } = params
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API['end-of-journey-templates'].deleteQuestions.url, {
          id: templateId
        }),
        input
      )
    )
    .delete()
}
